import React from "react";
import InfoIcon from "../../assets/images/icons/information_sessionexpire.svg";
import warningImg from "../../assets/images/icons/warning.png";
import { IoIosInformationCircleOutline } from "react-icons/io";

const ErrorInformationpopup = ({t, onClose  }) => {
  return (
    <>
      <div className="error-info-msg">
        <span className="close" onClick={onClose}></span>
        <div class="info-icon">
         <IoIosInformationCircleOutline />
          <p>{t("information")}</p>
        </div>
        <div className="header_bottom_border"></div>
        <p id="commonToasterHeading" className="message">
            <div className="warning"><img src={warningImg}/>
            </div>
                  <div className="err-msg">
                 {t("account_blocked")}
                  </div>
        </p>
      </div>
    </>
  );
};

export default ErrorInformationpopup;
